import { ACTIVE, INACTIVE } from "~/constants/entityStatus";

export const entityStoreStatus = {
  getters: {
    listOfActive: (state) =>
      state.list ? state.list.filter((item) => item.statusId === ACTIVE) : [],
    listOfInactive: (state) =>
      state.list ? state.list.filter((item) => item.statusId === INACTIVE) : [],
    listOfStable: (state) =>
      state.list
        ? state.list.filter(
          (item) => item.statusId === ACTIVE || item.statusId === INACTIVE
        )
        : []
  }
};